import { DistributionChannel } from "@deliverr/replenishment-client";
import { defineMessages } from "react-intl";

export const selectEcomDestinationLabels = {
  placeholder: defineMessages({
    id: "transfers.create.steps.destination.selectEcomDestination",
    defaultMessage: "Select Ecom Destination",
  }),
  ecomDestination: defineMessages({
    [DistributionChannel.ECOM_VIA_CROSSDOCK]: {
      id: "transfers.create.steps.destination.selectEcomDestination.ecom",
      defaultMessage: "Forwarding Plan",
    },
    [DistributionChannel.ECOM_DIRECT_TO_FC]: {
      id: "transfers.create.steps.destination.selectEcomDestination.ecomDirect",
      defaultMessage: "Direct Plan",
    },
  }),
  ecomDescription: defineMessages({
    [DistributionChannel.ECOM_VIA_CROSSDOCK]: {
      id: "transfers.create.steps.destination.selectEcomDestination.ecom.description",
      defaultMessage: "Distribute inventory across FCs",
    },
    [DistributionChannel.ECOM_DIRECT_TO_FC]: {
      id: "transfers.create.steps.destination.selectEcomDestination.ecomDirect.description",
      defaultMessage: "Transfer directly to a FC",
    },
  }),
};
